import React, { useMemo, useRef, useEffect, useState } from 'react'
import { List, Avatar } from 'antd'
import Title from '../icon'
import './index.less'

import { reducer, effect } from '../../../dva16'
import { NInfo, EGetInfo, RSetState, EGetSearch, EPostLikeInfo } from '../../../models/constants'

const handleChangeCollectionStatus = (item) => {
  effect(NInfo, EPostLikeInfo, { id: parseInt(item.id), infoID: parseInt(item.id) })
}

function foot(item) {
  return (
    <div className="foot">
      <div className="footLeft">
        <span>{item.user && item.user.role && item.user.role.name}</span>
        <span>发布于：{item.createdAt}</span>
      </div>
      <div className="footRight">
        <img onClick={()=>{handleChangeCollectionStatus(item)}} src={item.myLike ? require('../../static/like-2.svg') : require('../../static/like.svg')} alt="" />
        <span>{item.likeCount}</span>
        <img src={require('../../static/view.svg')} alt="" />
        <span>{item.visitCount}</span>
        <img src={require('../../static/reply.svg')} alt="" />
        <span> {item.commentCount}</span>
      </div>
    </div>
  )
}
function ArticleList(data = [], pages = {}, isSearch) {
  return (
    <List
      className="articleList"
      itemLayout="horizontal"
      dataSource={data}
      pagination={{
        total: pages.total,
        current: pages.defaultPage,
        onChange: page => {
          if (isSearch && !isSearch.query) {
            reducer(NInfo, RSetState, { categoryID: 2, pager: page })
            effect(NInfo, EGetInfo)
          } else {
            effect(NInfo, EGetSearch, { page, ...isSearch })
          }

          sessionStorage.removeItem('categoryID2')
          sessionStorage.setItem('categoryID2', page)
        },
        pageSize: pages.pageSize || 6,
      }}
      renderItem={item => (
        <List.Item>
          <List.Item.Meta
            avatar={<Avatar size={49} src={item.user&&item.user.icon || require('../../static/avatar.svg')} />}
            title={Title(item)}
            description={foot(item)}
          />
        </List.Item>
      )}
    />
  )
}

export default ArticleList
